import { render, staticRenderFns } from "./ChangeSellerHolder.vue?vue&type=template&id=7f929fa2&scoped=true"
import script from "./ChangeSellerHolder.vue?vue&type=script&lang=js"
export * from "./ChangeSellerHolder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f929fa2",
  null
  
)

export default component.exports